import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    ButtonProps
} from '@mui/material';

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    content: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmButtonProps?: ButtonProps;
    cancelButtonProps?: ButtonProps;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    content,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    confirmButtonProps,
    cancelButtonProps
}) => {
    let confirmTextValue = confirmText ?? 'Confirm';
    let cancelTextValue = cancelText ?? 'Cancel';
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} {...cancelButtonProps}>
                    {cancelTextValue}
                </Button>
                <Button onClick={onConfirm} variant="contained" {...confirmButtonProps}>
                    {confirmTextValue}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog; 